import React from 'react';
import { Link } from 'react-router-dom';
import { BUSINESS } from '../constants';

const Footer: React.FC = () => {
  return (
    <footer
      className="relative text-white/60 pt-16 pb-8 px-5 sm:px-10 mt-20 overflow-hidden"
      style={{ backgroundImage: "url('/images/sections/footer-bg.webp')", backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <div className="absolute inset-0 bg-brand-navy/90 z-[1]" aria-hidden="true" />

      <div className="relative z-[2]">
        <div className="max-w-[1280px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="font-display font-extrabold text-[22px] text-white mb-3">The Yaad Shop 🇨🇦</div>
            <p className="text-sm leading-relaxed mb-5">Multicultural wholesale supplier based in the Greater Toronto Area. Bringing authentic products from around the world to Canadian businesses since day one.</p>
            <div className="flex items-center gap-2 bg-white/5 rounded-lg px-3.5 py-2.5 text-[13px] w-fit">
              💳 Payments via <span className="text-brand-gold font-semibold">Interac e-Transfer</span>
            </div>
          </div>

          {/* Shop */}
          <div>
            <div className="font-display font-bold text-sm text-white uppercase tracking-wider mb-5">Shop</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/shop" className="hover:text-brand-gold transition-colors">All Products</Link></li>
              <li><Link to="/shop" className="hover:text-brand-gold transition-colors">Machetes</Link></li>
              <li><Link to="/shop" className="hover:text-brand-gold transition-colors">Flag Bandanas</Link></li>
              <li><Link to="/shop" className="hover:text-brand-gold transition-colors">Caps &amp; Hats</Link></li>
              <li><Link to="/shop" className="hover:text-brand-gold transition-colors">Flags &amp; Accessories</Link></li>
              <li><Link to="/shop" className="hover:text-brand-gold transition-colors">Smudge Sticks</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <div className="font-display font-bold text-sm text-white uppercase tracking-wider mb-5">Company</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="hover:text-brand-gold transition-colors">About Us</Link></li>
              <li><Link to="/news" className="hover:text-brand-gold transition-colors">News &amp; Promotions</Link></li>
              <li><Link to="/faq" className="hover:text-brand-gold transition-colors">FAQ</Link></li>
              <li><Link to="/apply" className="hover:text-brand-gold transition-colors">Wholesale Application</Link></li>
              <li><Link to="/contact" className="hover:text-brand-gold transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="font-display font-bold text-sm text-white uppercase tracking-wider mb-5">Contact</div>
            <ul className="space-y-2.5 text-sm">
              <li><a href="mailto:info@theyaadshop.com" className="hover:text-brand-gold transition-colors">info@theyaadshop.com</a></li>
              <li><a href={`https://wa.me/${BUSINESS.whatsapp}`} target="_blank" rel="noopener noreferrer" className="hover:text-brand-gold transition-colors">WhatsApp</a></li>
              <li><span>Greater Toronto Area, ON</span></li>
              <li><span>Canada</span></li>
            </ul>
          </div>
        </div>

        <div className="max-w-[1280px] mx-auto pt-7 border-t border-white/[0.08] flex flex-col md:flex-row items-center justify-between gap-4 text-[13px]">
          <div>&copy; {new Date().getFullYear()} The Yaad Shop. All rights reserved. <span className="text-lg ml-1">🇨🇦 🇯🇲 🇳🇬 🇬🇭 🇨🇳 🇵🇭 🇲🇽 🇹🇹</span></div>
          <div className="flex gap-5">
            <button className="text-white/40 hover:text-brand-gold transition-colors">Privacy Policy</button>
            <button className="text-white/40 hover:text-brand-gold transition-colors">Terms of Service</button>
            <button className="text-white/40 hover:text-brand-gold transition-colors">Shipping Policy</button>
          </div>
        </div>

        {/* Multicultural stripe */}
        <div className="mt-8 flex h-1.5">
          <div className="flex-1 bg-brand-red" />
          <div className="flex-1 bg-brand-gold" />
          <div className="flex-1 bg-brand-green" />
          <div className="flex-1 bg-brand-navy" />
          <div className="flex-1 bg-brand-earth" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
